import React from 'react';
export function LiveIndicator() {
  return <div className="flex items-center gap-2 bg-green-900/30 px-3 py-1 rounded-full" data-id="element-401" data-mp="2jftbmokzoizt">
      <div className="relative" data-id="element-402" data-mp="wnk3tmk9i5th">
        <div className="absolute inset-0 bg-green-600 rounded-full animate-ping opacity-75" data-id="element-403" data-mp="wqodv0kervs2"></div>
        <div className="relative w-3 h-3 bg-green-600 rounded-full" data-id="element-404" data-mp="ivmaol6y4kiy"></div>
      </div>
      <span className="font-bold text-sm uppercase" data-id="element-405" data-mp="nup7xjgopmgd">Live</span>
    </div>;
}